import React, {Component} from 'react';


class Loader extends Component {
    render() {
        const {messageOne, messageTwo} = this.props;
        return (
            <div className="loader-container">
                {
                    messageOne ? <div className="loading-message">{messageOne}</div> : null
                }
                <div className="loader"/>
                <img className="logo-loader" src={process.env.PUBLIC_URL + '/solvecube.png'} alt=""/>
                {
                    messageTwo ? <div className="loading-message">{messageTwo}</div> : null
                }
            </div>
        )
    }
}

export default Loader;